import "../../static/logo.css";
import React from "react";



const Logo = () => {
    return (
        <div className="logo">
            <h1 className="neon-text">
                FreshScope
            </h1>
        </div>
    );
};

export default Logo;